var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg37(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1378 0.467773H2.86223C1.284 0.467773 0 1.75177 0 3.33001V13.6709C0 15.2491 1.284 16.5331 2.86223 16.5331H21.1378C22.716 16.5331 24 15.2491 24 13.6709V3.33001C24 1.75177 22.716 0.467773 21.1378 0.467773ZM21.1378 15.1269H7.32389L1.40625 9.20921V3.33001C1.40625 2.52718 2.05941 1.87402 2.86223 1.87402H16.6761L22.5938 7.79171V13.6709C22.5938 14.4737 21.9406 15.1269 21.1378 15.1269ZM1.40625 13.6709V11.198L5.33517 15.1269H2.86223C2.05941 15.1269 1.40625 14.4737 1.40625 13.6709ZM22.5938 3.33001V5.80295L18.6648 1.87402H21.1378C21.9406 1.87402 22.5938 2.52718 22.5938 3.33001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 5.12598H12.7031V11.8756H11.2969V5.12598Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3944 5.12598H14.2034H14.2012L14.2034 11.8756H15.6097V9.55084C15.9001 9.54938 16.2125 9.54802 16.3944 9.54802C17.6298 9.54802 18.635 8.55615 18.635 7.33698C18.6349 6.11785 17.6298 5.12598 16.3944 5.12598ZM16.3944 8.14182C16.213 8.14182 15.9048 8.14313 15.6162 8.14454C15.6147 7.8452 15.6126 6.84507 15.6117 6.53223H16.3944C16.8466 6.53223 17.2287 6.90076 17.2287 7.33702C17.2287 7.77329 16.8467 8.14182 16.3944 8.14182Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87792 5.11914L7.47955 9.32973L6.02492 5.11914H4.53711L6.87111 11.8752H8.11592L10.3597 5.11914H8.87792Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg37);
export default __webpack_public_path__ + "static/media/37.39e7dd878dc2acd3eaf01898bb7a425c.svg";
export { ForwardRef as ReactComponent };